// extracted by mini-css-extract-plugin
export var repoGrid = "projects-module--repoGrid--HCDb4";
export var reposWrap = "projects-module--reposWrap--3wk5x";
export var reposWrapDark = "projects-module--reposWrapDark--et1Ui";